@for(tab of labels; track tab.value) {
	<div class="cds-whitespace-nowrap" [class]="'tab' + ($index === active() ? ' active':'')" (click)="changeTab($index, tab)">
		<span class="cds-inline md:cds-hidden">{{tab.shortLabel ?? tab.label}}</span>
		<span class="cds-hidden md:cds-inline">{{tab.label}}</span>
	</div>
}
